import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { Box, Tabs } from '@factorialco/deprecated-design-system'

import { useNodeTabs } from './useNodeTabs'

export function NodeTabs() {
  const location = useLocation()
  const navigate = useNavigate()

  const tabs = useNodeTabs()

  return (
    <Box position="relative" width="full">
      <Tabs currentId={location.pathname} onTabClicked={(to: string) => navigate(to)}>
        {tabs.map(({ id, label }) => (
          <Tabs.Tab key={id} id={id} label={label} />
        ))}
      </Tabs>
    </Box>
  )
}
